module.exports = __webpack_public_path__ + "img/step25_a_install supports.d7067e41.png";